import {
  FETCH_SESSION_COLORS,
  FETCH_SCHEDULES_DATA_PENDING,
  FETCH_SCHEDULES_DATA_FULFILLED,
  FETCH_SCHEDULES_DATA_REJECTED,
  ADD_SCHEDULE_TRACK,
  SELECT_SCHEDULE_DATE,
  OPEN_TRACK_MODAL,
  OPEN_SESSION_MODAL,
  OPEN_SESSION_PRIVATE_USER_MODAL,
  UPDATE_SESSION_FILES,
  HEIGHT_PER_HOUR,
  MIN_ZOOM,
} from "ScheduleConstants";
import {
  IMPORT_SCHEDULE_MODAL,
  SESSION_ASSOCIATED_USERS,
  SESSION_RSVP_USERS,
  SCHEDULES_ASSIGNED_SPEAKERS,
  SESSION_SCREEN_ZOOM,
  BULLKEDIT_MODAL_CONTROL,
} from "ContentActions";
import LocaleStrings from "Languages";

var initialState = {
  payload: {},
  isFetching: true,
  error: false,
};

export function SchedulesDataReducers(state = initialState, action) {
  switch (action.type) {
    case FETCH_SCHEDULES_DATA_PENDING:
      return { ...state, payload: {}, isFetching: true };
    case FETCH_SCHEDULES_DATA_FULFILLED:
      return {
        ...state,
        payload: action.payload.resource[0],
        isFetching: false,
      };
    case FETCH_SCHEDULES_DATA_REJECTED:
      return { ...state, isFetching: false, payload: {}, error: true };
    default:
      return state;
  }
}

export function SchedulesTrackReducer(state = [], action) {
  switch (action.type) {
    case ADD_SCHEDULE_TRACK:
      return [...state, action.payload];
    default:
      return state;
  }
}

export function SessionColorsReducer(state = [], action) {
  switch (action.type) {
    case FETCH_SESSION_COLORS:
      return { payload: action.payload.resource };
    default:
      return state;
  }
}

export function SelectedScheduleDateReducer(state = {}, action) {
  switch (action.type) {
    case SELECT_SCHEDULE_DATE:
      return action.payload;
    default:
      return state;
  }
}

export function TrackPopupReducer(
  state = { status: false, track: {} },
  action
) {
  switch (action.type) {
    case OPEN_TRACK_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function SessionPopupReducer(
  state = { status: false, session: {} },
  action
) {
  switch (action.type) {
    case OPEN_SESSION_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function sessionPrivateUsersModal(state = {}, action) {
  switch (action.type) {
    case OPEN_SESSION_PRIVATE_USER_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function sessionfilesList(
  state = [
    { position: "file1", file: "", filename: "" },
    { position: "file2", file: "", filename: "" },
    { position: "file3", file: "", filename: "" },
    { position: "file4", file: "", filename: "" },
    { position: "file5", file: "", filename: "" },
  ],
  action
) {
  switch (action.type) {
    case UPDATE_SESSION_FILES:
      return action.payload;
    default:
      return state;
  }
}

export var sendPushTimes = (state = [], action) => {
  //iconName is optional
  var state = [
    { name: "5 minutes", value: "5", id: 1 },
    { name: "10 minutes", value: "10", id: 2 },
    { name: "15 minutes", value: "15", id: 3 },
    { name: "20 minutes", value: "20", id: 4 },
    { name: "25 minutes", value: "25", id: 5 },
    { name: "30 minutes", value: "30", id: 6 },
  ];

  return state;
};
export var checkinType = (state = [], action) => {
  //iconName is optional
  var state = [
    {
      name: LocaleStrings.schedule_form_checkintype_option1,
      value: "nocheckinneeded",
      id: 1,
    },
    {
      name: LocaleStrings.schedule_form_checkintype_option2,
      value: "selfcheckin",
      id: 2,
    },
    // {
    //   name: LocaleStrings.schedule_form_checkintype_option3,
    //   value: "scanqr",
    //   id: 3,
    // },
    // {
    //   name: LocaleStrings.schedule_form_checkintype_option4,
    //   value: "showqr",
    //   id: 4,
    // },
    {
      name: LocaleStrings.schedule_form_checkintype_option5,
      value: "bothside",
      id: 5,
    },
  ];

  return state;
};

export function scheduleImportModal(state = {}, action) {
  switch (action.type) {
    case IMPORT_SCHEDULE_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function singleSessionAssociatedUsers(state = {}, action) {
  switch (action.type) {
    case SESSION_ASSOCIATED_USERS:
      return action.payload;
    default:
      return state;
  }
}

export function singleSessionRSVPUsers(state = {}, action) {
  switch (action.type) {
    case SESSION_RSVP_USERS:
      return action.payload;
    default:
      return state;
  }
}

export function sessionAssociatedSpeakers(state = [], action) {
  switch (action.type) {
    case SCHEDULES_ASSIGNED_SPEAKERS:
      return action.payload;
    default:
      return state;
  }
}

export function sessionScreenZoom(
  state = { zoom: MIN_ZOOM, height: HEIGHT_PER_HOUR },
  action
) {
  switch (action.type) {
    case SESSION_SCREEN_ZOOM:
      return action.payload;
    default:
      return state;
  }
}

export const bulkEditModalControlReducer = (state = {}, action) => {
  if (action.type == BULLKEDIT_MODAL_CONTROL) return action.payload;
  return state;
};
